// Inline SVG of an ash tree (fresno) leaf branch — no butterfly, uses brand colors
export default function FresnoLeaf({ className = "", style = {} }) {
  return (
    <svg
      viewBox="0 0 120 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="fl1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#a5b58e" />
          <stop offset="60%" stopColor="#7a8e5a" />
          <stop offset="100%" stopColor="#4d6a3a" />
        </linearGradient>
        <linearGradient id="fl2" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#b8c99a" />
          <stop offset="60%" stopColor="#7a8e5a" />
          <stop offset="100%" stopColor="#3d5a2a" />
        </linearGradient>
      </defs>

      {/* Central stem */}
      <path
        d="M60 195 C60 155, 60 115, 60 40"
        stroke="#4d6a3a"
        strokeWidth="1.8"
        fill="none"
        strokeLinecap="round"
      />

      {/* Leaf 1 — bottom-left */}
      <g transform="translate(60 165) rotate(-45)">
        <path
          d="M0 0 C -6 -10, -12 -22, -8 -34 C -3 -40, 4 -40, 6 -32 C 6 -20, 3 -8, 0 0 Z"
          fill="url(#fl1)"
        />
        <path d="M0 0 L 0 -34" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Leaf 2 — bottom-right */}
      <g transform="translate(60 155) rotate(50)">
        <path
          d="M0 0 C 6 -10, 12 -22, 8 -34 C 3 -40, -4 -40, -6 -32 C -6 -20, -3 -8, 0 0 Z"
          fill="url(#fl2)"
        />
        <path d="M0 0 L 0 -34" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Leaf 3 — mid-left */}
      <g transform="translate(60 120) rotate(-55)">
        <path
          d="M0 0 C -8 -14, -14 -28, -10 -42 C -4 -50, 5 -50, 7 -40 C 7 -25, 4 -10, 0 0 Z"
          fill="url(#fl1)"
        />
        <path d="M0 0 L 0 -42" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Leaf 4 — mid-right */}
      <g transform="translate(60 108) rotate(60)">
        <path
          d="M0 0 C 8 -14, 14 -28, 10 -42 C 4 -50, -5 -50, -7 -40 C -7 -25, -4 -10, 0 0 Z"
          fill="url(#fl2)"
        />
        <path d="M0 0 L 0 -42" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Leaf 5 — top-left */}
      <g transform="translate(60 70) rotate(-45)">
        <path
          d="M0 0 C -6 -10, -12 -22, -8 -34 C -3 -40, 4 -40, 6 -32 C 6 -20, 3 -8, 0 0 Z"
          fill="url(#fl1)"
        />
        <path d="M0 0 L 0 -34" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Leaf 6 — top-right */}
      <g transform="translate(60 60) rotate(50)">
        <path
          d="M0 0 C 6 -10, 12 -22, 8 -34 C 3 -40, -4 -40, -6 -32 C -6 -20, -3 -8, 0 0 Z"
          fill="url(#fl2)"
        />
        <path d="M0 0 L 0 -34" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>

      {/* Tip leaf */}
      <g transform="translate(60 30)">
        <path
          d="M0 0 C -5 -8, -8 -20, -4 -28 C 0 -32, 4 -32, 4 -28 C 8 -20, 5 -8, 0 0 Z"
          fill="url(#fl1)"
        />
        <path d="M0 0 L 0 -28" stroke="#4d6a3a" strokeWidth="0.8" fill="none" />
      </g>
    </svg>
  );
}
